import { render, staticRenderFns } from "./ImpluseIframe.vue?vue&type=template&id=b23e51ca&scoped=true&"
import script from "./ImpluseIframe.vue?vue&type=script&lang=js&"
export * from "./ImpluseIframe.vue?vue&type=script&lang=js&"
import style0 from "./ImpluseIframe.vue?vue&type=style&index=0&id=b23e51ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23e51ca",
  null
  
)

export default component.exports